import CloseIcon from '@mui/icons-material/Close';
import { Button, IconButton, Paper, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { CONTACT_URL, PHONE_HREF, PHONE_LABEL } from './demoLinks.ts';

const DISMISSED_KEY = 'forge-talk-to-nick-dismissed';

const wasDismissed = () => {
  try {
    return sessionStorage.getItem(DISMISSED_KEY) === '1';
  } catch {
    return false;
  }
};

/** No sign-up means no lead unless the visitor can reach a person. Dismissed for the visit only. */
const TalkToNick = () => {
  const [hidden, setHidden] = useState(wasDismissed);

  if (hidden) return null;

  const dismiss = () => {
    try {
      sessionStorage.setItem(DISMISSED_KEY, '1');
    } catch {
      // Private browsing can throw; hiding for this render is enough.
    }
    setHidden(true);
  };

  return (
    <Paper
      elevation={8}
      sx={{
        position: 'fixed',
        // Clear of the sticky action bar the edit pages put at the bottom on
        // small screens.
        bottom: { xs: 88, md: 24 },
        right: { xs: 16, sm: 24 },
        zIndex: (theme) => theme.zIndex.snackbar - 1,
        maxWidth: 300,
        p: 2,
        pr: 5,
        borderRadius: 2
      }}
    >
      <IconButton
        size="small"
        onClick={dismiss}
        aria-label="Hide this"
        sx={{ position: 'absolute', top: 4, right: 4 }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
      <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
        Questions? Talk to Nick
      </Typography>
      <Typography variant="body2" sx={{ mt: 0.5, color: 'text.secondary' }}>
        Look around as long as you like. When you want to see it with your own relationships, this
        is the fastest way.
      </Typography>
      <Stack direction="row" spacing={1} sx={{ mt: 1.5 }}>
        <Button size="small" variant="contained" href={CONTACT_URL} target="_blank" rel="noopener">
          Get in touch
        </Button>
        <Button size="small" variant="outlined" href={PHONE_HREF}>
          {PHONE_LABEL}
        </Button>
      </Stack>
    </Paper>
  );
};

export default TalkToNick;
